import type { TCreateMediaFile, TMediaFileBase } from '@onesource/schemas';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { axiosServiceInstance } from '../axios';
import { MEDIA_ENTITY } from './entity';

export const useCreateMediaFileMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<TMediaFileBase, Error, TCreateMediaFile>({
    mutationFn: async (dto: TCreateMediaFile) => {
      const res = await axiosServiceInstance.post<TMediaFileBase>(`/${MEDIA_ENTITY}`, dto);
      return res.data;
    },
    onSuccess: () => {
      // Invalidate everything under the media key — refreshes the grid AND the upload-quota usage.
      queryClient.invalidateQueries({ queryKey: [MEDIA_ENTITY], exact: false });
    },
  });
};
